import { object, string, bool } from "yup";
function getSchema() {
  const { t } = useI18n();

  const schema = object().shape(
    {
      email: string()
        .email(t("validationMessages.email"))
        .required(t("validationMessages.requiredField"))
        .preventEmojis(t("validationMessages.invalidCharacters")),
      customer_cell_phone: string()
        .required(t("validationMessages.requiredField"))
        .preventEmojis(t("validationMessages.invalidCharacters")),
      customer_name: string()
        .required(t("validationMessages.requiredField"))
        .preventEmojis(t("validationMessages.invalidCharacters"))
        .min(3, t("validationMessages.moreThan2Characters")),
      customer_surname: string()
        .required(t("validationMessages.requiredField"))
        .preventEmojis(t("validationMessages.invalidCharacters"))
        .min(3, t("validationMessages.moreThan2Characters")),
      cell_phone_prefix: string()
        .required(t("validationMessages.requiredField"))
        .preventEmojis(t("validationMessages.invalidCharacters")),
      gdpr_privacy: bool()
        .required(t("validationMessages.shouldAcceptConsent"))
        .oneOf([true], t("validationMessages.shouldAcceptConsent")),
      customer_birthday: string()
        .min(1, t("validationMessages.moreThan2Characters"))
        .required(t("validationMessages.requiredField")),
      store: string()
        .required(t("validationMessages.requiredField"))
        .preventEmojis(t("validationMessages.invalidCharacters")),
      customer_gender: string()
        .required(t("validationMessages.requiredField"))
        .preventEmojis(t("validationMessages.invalidCharacters")),

      customer_address: string().when(
        ["customer_province", "customer_city", "customer_zip"],
        {
          is: (
            customer_province: string,
            customer_city: string,
            customer_zip: string,
          ) => customer_province || customer_city || customer_zip,
          then: (schema) =>
            schema
              .required(
                "Si uno de los campos está llenado, todos son obligatorios",
              )
              .preventEmojis(t("validationMessages.invalidCharacters")),
        },
      ),
      customer_province: string().when(
        ["customer_address", "customer_city", "customer_zip"],
        {
          is: (
            customer_address: string,
            customer_city: string,
            customer_zip: string,
          ) => customer_address || customer_city || customer_zip,
          then: (schema) =>
            schema
              .required(
                "Si uno de los campos está llenado, todos son obligatorios",
              )
              .preventEmojis(t("validationMessages.invalidCharacters")),
        },
      ),
      customer_city: string().when(
        ["customer_province", "customer_address", "customer_zip"],
        {
          is: (
            customer_province: string,
            customer_address: string,
            customer_zip: string,
          ) => customer_province || customer_address || customer_zip,
          then: (schema) =>
            schema
              .required(
                "Si uno de los campos está llenado, todos son obligatorios",
              )
              .preventEmojis(t("validationMessages.invalidCharacters")),
        },
      ),
      customer_zip: string().when(
        ["customer_province", "customer_city", "customer_address"],
        {
          is: (
            customer_province: string,
            customer_city: string,
            customer_address: string,
          ) => customer_province || customer_city || customer_address,
          then: (schema) =>
            schema
              .required(
                "Si uno de los campos está llenado, todos son obligatorios",
              )
              .preventEmojis(t("validationMessages.invalidCharacters")),
        },
      ),
    },
    [
      ["customer_address", "customer_province"],
      ["customer_address", "customer_city"],
      ["customer_address", "customer_zip"],
      ["customer_province", "customer_city"],
      ["customer_province", "customer_zip"],
      ["customer_city", "customer_zip"],
    ],
  );

  return schema;
}

export { getSchema };
